import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { Icon } from "@iconify/react";
import { Fade } from "react-awesome-reveal";

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Button from "../../components/Button/Button";
// import StringInput from "../../components/Input/StringInput/StringInput";
// import NumberInput from "../../components/Input/NumberInput/NumberInput";
import DataTable from "../../components/Datatable/DataTable";
import DateScroller from '../../components/MobileAssets/DateScroller/DateScroller';
import { default as ReactSelect } from "react-select";

const options = [
    { value: "all", label: "All" },
    { value: "success", label: "Success" },
    { value: "fail", label: "Failed" },
  ];

class MobileDepositHistory extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state =
        {
            // filterShow: '',
        };
    }

    // showDateHandler = () => 
    // {
    //     this.setState({
    //         filterShow: 'date'
    //     })
    // }

    imageImport = (r) => 
    {
        let images = {};
        r.keys().map((item, index) => 
        {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    }

    render() 
    {
        const { t } = this.props;
        const resetIcon = this.imageImport(require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/));
        // const icons = this.imageImport(require.context("../../assets/images/icons", false, /\.(png|jpe?g|svg)$/));
        // const img = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));
        // const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
        // console.log(this.props)

        return (
            <Auxiliary>
                <DateScroller
                    onChangeDateHandler={this.props.onChangeDateHandler}
                    toggleShowDateSelect={this.props.toggleShowDateSelect}
                    {...this.state}
                    {...this.props}
                />
                <section className="pf-m-dashboard">
                    <div className={`filters-m-col ${this.props.filterShow ? 'show' : ''}`}>
                        {/* <MobileSubHeader
                            className="bg-white"
                            returnPage="/me"
                            header={t('profile-sidebar.betting-history')}
                            style={{ justifyContent: "unset" }}
                        /> */}
                        <div className="filters-m-panel">
                            <div className="filter-m-tp-col">
                                <div className="filter-m-cat">
                                    {/* <label className="filter-m-label">{t('history.type')}:</label> */}
                                    <label className="filter-m-label">{t('delegate-deposit.member')}: </label>
                                    {/* <button className={`btn btn-m-filter type`}>
                                        <StringInput
                                            id="member"
                                            name="member"
                                            className={`form-control`}
                                            value={this.props.member}
                                            placeholder='Member'
                                            onChange={(event) => this.props.onInputChangeHandler(event)}
                                            onSearchPress={(evt) => evt.key === "Enter" && this.props.searchHandler()}
                                        />
                                    </button> */}
                                    
                                    <ReactSelect
                                        id='memberId'
                                        name='memberId'
                                        classNamePrefix="react-select"
                                        className="filter-provider btn btn-m-filter select"
                                        placeholder={t('delegate-deposit.select-member')}
                                        options={this.props.downlineList}
                                        onChange={this.props.memberChangeHandler}
                                        value={(this.props.memberId !== '') ? this.props.downlineList[this.props.memberId] : ''}
                                    />
                                </div>
                            </div>
                            <div className="filter-m-tp-col">
                                <div className="filter-m-cat">
                                    <label className="filter-m-label">{t('history.date')}:</label>
                                    <button className={`btn btn-m-filter date ${this.props.filterShow === 'status' && 'active'}`} type="button" onClick={this.props.showDateHandler}>
                                        <p>
                                            {this.props.startDate}
                                            <br />
                                            {this.props.endDate}
                                        </p>
                                        <Icon icon="uil:angle-down" />
                                    </button>
                                </div>
                                <div className="filter-m-cat">
                                    <Button
                                        typeButton="button"
                                        classValue="btn btn-gradient-blue "
                                        idValue="search"
                                        buttonName={t('global.check')}
                                        clicked={() => { this.props.searchHandler(); this.setState({ filterShow: '' }); }}
                                        // disabled={this.props.disableSearchButton}
                                    />
                                    {/* <Button
                                        typeButton='button'
                                        classValue='btn btn-success'
                                        idValue='reset'
                                        buttonName={t('global.reset')}
                                        clicked={()=>{this.props.onResetHandler(); this.setState({ filterShow: '' });}}
                                    /> */}
                                    <button className="reset-btn" onClick={()=>{this.props.onResetHandler(); this.setState({ filterShow: '' });}}> 
                                    <img className={`${this.state.spin ? "spin" : ""} `} src={resetIcon["rotate-icon.svg"]} alt="reset" />
                                    </button>
                                    </div>
                            </div>
                            <div className="filter-m-btm-col">
                            <div className={`filters-m-date-group ${this.props.filterShow === 'date' ? 'd-block' : 'd-none'}`}>
                                <div className="d-flex align-items-center flex-wrap">
                                    {this.props.filterDate && this.props.filterDate.map((item, index) => (
                                        <div className="form-check form-check-inline filter" key={index}>
                                            <input
                                                className="btn-check"
                                                type="radio"
                                                name="filterDate"
                                                id={item.id}
                                                value={item.value}
                                                defaultChecked={index === 0}
                                                checked={index === this.props.currentFilterDate}
                                                onClick={() => this.props.onChangeFilterDateHandler(index)}
                                            />
                                            <label className="btn form-check-label" htmlFor={item.id} onClick={
                                                () => [
                                                    this.props.filterDayRange(item.value)
                                                ]
                                            }>
                                                {t(`history.${item.label}`)}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                                <div className="filter-m-date">
                                    <label className="filter-m-label">{t('history.start-date')}:</label>
                                    <button className="btn btn-m-filter-date" type="button" onClick={(e) => this.props.toggleShowDateSelect(e, 'startDate')}>
                                        <p>{this.props.startDate}</p>
                                        <Icon icon="uil:angle-right" />
                                    </button>
                                </div>
                                <div className="filter-m-date">
                                    <label className="filter-m-label">{t('history.end-date')}:</label>
                                    <button className="btn btn-m-filter-date" type="button" onClick={(e) => this.props.toggleShowDateSelect(e, 'endDate')}>
                                        <p>{this.props.endDate}</p>
                                        <Icon icon="uil:angle-right" />
                                    </button>
                                </div>
                            </div>
                            {/* {this.props.filterShow &&
                                <>
                                    <Button
                                        typeButton="button"
                                        classValue="btn btn-gradient-blue mt-3"
                                        idValue="search"
                                        buttonName={t('global.check')}
                                        clicked={() => { this.props.searchHandler(); this.setState({ filterShow: '' }); }}
                                        disabled={this.props.disableSearchButton}
                                    />
                                    <Button
                                        typeButton='button'
                                        classValue='btn btn-success w-100'
                                        idValue='reset'
                                        buttonName={t('global.reset')}
                                        clicked={()=>{this.props.onResetHandler(); this.setState({ filterShow: '' });}}
                                    />
                                </>
                            } */}
                        </div>
                        </div>


                    </div>
                    <div className="overlay" onClick={this.props.offDateHandler}/>
                    <div className="pd-m-card-col">
                        <Fade duration={1000} triggerOnce>
                            <DataTable
                                keyField="no"
                                data={this.props.data}
                                columns={this.props.columns}
                                activePage={this.props.activePage}
                                limit={this.props.limit}
                                totalItems={this.props.totalRecords}
                                paginationHandler={(val) => this.props.datatablesChangeHandler(val, "activePage")}
                                // sizePerPageHandler={(val) => this.datatablesChangeHandler(val, "limit")}
                                loading={this.props.loading}
                                hideSearchBar={true}
                                hideTotalRecords={true}
                                classValue="pd-table"
                                component="delegate-deposit-history"
                            />
                        </Fade>
                    </div>
                </section>
            </Auxiliary>
        );
    }
}

export default withNamespaces("translation")(MobileDepositHistory);